var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{ref:"widgetContainer",staticClass:"savage-widget"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }